import { InvoicePaymentService } from '@/clients/InvoicePaymentService'
import Merchant from '@/entities/Merchant'

export const createSyntheticInvoice = async (_, payload) => {
  const client = new InvoicePaymentService()
  const { synthetic_invoice: invoice } = await client.createSyntheticInvoice(payload)
  return invoice.id
}

export const getMerchantByPractice = async () => {
  const client = new InvoicePaymentService()
  const merchant = await client.getMerchantByPractice()
  return new Merchant(merchant)
}
